import React from "react";
import {useFormContext} from "react-hook-form";

import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';

import * as CustomStyles from '../../styles/CustomStyles';
import CustomSelect from '../../custom/CustomSelectComponent'
import * as SelectTypes from '../../constants/CustomSelectTypes'
import * as ValidationMessages from '../../constants/ValidationMessages';
import * as DataPattern from '../../constants/DataPattern';


export const WorksiteDetails = (props) => {
    console.log('WorksiteDetails Component___');

    const { register, setValue, formState: { errors, defaultValues } } = useFormContext();

    return(
        <React.Fragment>

                    <Grid container spacing={2} sx={CustomStyles.gridStyles}>
                        {/*row*/}
                        <Grid item xs={12}>
                            <TextField variant="standard" size="small" label="Nume" fullWidth margin="dense" 
                                {...register("lWorksite.generalSection.name", {required: ValidationMessages.REQUITED_MESSAGE})} 
                                error={!!errors?.lWorksite?.generalSection?.name}
                                helperText={errors?.lWorksite?.generalSection?.name ? errors.lWorksite.generalSection.name.message : null}
                            />
                        </Grid>

                        {/*row*/}
                        <Grid item xs={4}>
                            <CustomSelect 
                                selectId={'wlJudet'} 
                                selectType={SelectTypes.JUDETE} 
                                value={defaultValues.lWorksite.generalSection.judet} 
                                register={{...register('lWorksite.generalSection.judet', {required: ValidationMessages.REQUITED_MESSAGE})}}
                                error={!!errors?.lWorksite?.generalSection?.judet}
                                helperText={errors?.lWorksite?.generalSection?.judet ? errors.lWorksite.generalSection.judet.message : null}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField variant="standard" size="small" label="Localitate" fullWidth margin="dense" 
                                {...register("lWorksite.generalSection.localitate", {required: ValidationMessages.REQUITED_MESSAGE})} 
                                error={!!errors?.lWorksite?.generalSection?.localitate}
                                helperText={errors?.lWorksite?.generalSection?.localitate ? errors.lWorksite.generalSection.localitate.message : null}
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <TextField variant="standard" size="small" label="Sector" fullWidth margin="dense" 
                                {...register("lWorksite.generalSection.sector")} 
                                error={!!errors?.lWorksite?.generalSection?.sector}
                                helperText={errors?.lWorksite?.generalSection?.sector ? errors.lWorksite.generalSection.sector.message : null}
                            />
                        </Grid>

                        {/*row*/}
                        <Grid item xs={4}>
                            <TextField variant="standard" size="small" label="Cod Postal" fullWidth margin="dense" 
                                {...register("lWorksite.generalSection.postalCode", {required: ValidationMessages.REQUITED_MESSAGE})} 
                                error={!!errors?.lWorksite?.generalSection?.postalCode}
                                helperText={errors?.lWorksite?.generalSection?.postalCode ? errors.lWorksite.generalSection.postalCode.message : null}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField variant="standard" size="small" label="Strada" fullWidth margin="dense" 
                                {...register("lWorksite.generalSection.street", {required: ValidationMessages.REQUITED_MESSAGE})} 
                                error={!!errors?.lWorksite?.generalSection?.street}
                                helperText={errors?.lWorksite?.generalSection?.street ? errors.lWorksite.generalSection.street.message : null}
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <TextField variant="standard" size="small" label="Nr." fullWidth margin="dense" 
                                {...register("lWorksite.generalSection.no")} 
                                error={!!errors?.lWorksite?.generalSection?.no}
                                helperText={errors?.lWorksite?.generalSection?.no ? errors.lWorksite.generalSection.no.message : null}
                            />
                        </Grid>

                        {/*row*/}
                        <Grid item xs={2}>
                            <TextField variant="standard" size="small" label="Bloc" fullWidth margin="dense" 
                                {...register("lWorksite.generalSection.bloc")} 
                                error={!!errors?.lWorksite?.generalSection?.bloc}
                                helperText={errors?.lWorksite?.generalSection?.bloc ? errors.lWorksite.generalSection.bloc.message : null}
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <TextField variant="standard" size="small" label="Scara" fullWidth margin="dense" 
                                {...register("lWorksite.generalSection.scara")} 
                                error={!!errors?.lWorksite?.generalSection?.scara}
                                helperText={errors?.lWorksite?.generalSection?.scara ? errors.lWorksite.generalSection.scara.message : null}
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <TextField variant="standard" size="small" label="Etaj" fullWidth margin="dense" 
                                {...register("lWorksite.generalSection.etaj")} 
                                error={!!errors?.lWorksite?.generalSection?.etaj}
                                helperText={errors?.lWorksite?.generalSection?.etaj ? errors.lWorksite.generalSection.etaj.message : null}
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <TextField variant="standard" size="small" label="Apartament" fullWidth margin="dense" 
                                {...register("lWorksite.generalSection.apartment")} 
                                error={!!errors?.lWorksite?.generalSection?.apartment}
                                helperText={errors?.lWorksite?.generalSection?.apartment ? errors.lWorksite.generalSection.apartment.message : null}
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <TextField variant="standard" size="small" label="Buzzer" fullWidth margin="dense" 
                                {...register("lWorksite.generalSection.buzzer")} 
                                error={!!errors?.lWorksite?.generalSection?.buzzer}
                                helperText={errors?.lWorksite?.generalSection?.buzzer ? errors.lWorksite.generalSection.buzzer.message : null}
                            />
                        </Grid>
                        <Grid item xs={2}>
                        </Grid>

                        {/*row*/}
                        <Grid item xs={4}>
                            <TextField variant="standard" size="small" label="Nume Reprezentant Legal" fullWidth margin="dense" 
                                {...register("lWorksite.generalSection.legalRepresentativeName")} 
                                error={!!errors?.lWorksite?.generalSection?.legalRepresentativeName}
                                helperText={errors?.lWorksite?.generalSection?.legalRepresentativeName ? errors.lWorksite.generalSection.legalRepresentativeName.message : null}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <TextField variant="standard" size="small" label="Telefon Reprezentant Legal" fullWidth margin="dense" 
                                {...register("lWorksite.generalSection.legalRepresentativePhone",
                                    {pattern: {
                                        value: DataPattern.PATTERN_PHONE_NUMBER,
                                        message: ValidationMessages.INVALID_PHONE_NUMBER,
                                    }}
                                )} 
                                error={!!errors?.lWorksite?.generalSection?.legalRepresentativePhone}
                                helperText={errors?.lWorksite?.generalSection?.legalRepresentativePhone ? errors.lWorksite.generalSection.legalRepresentativePhone.message : null}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <TextField variant="standard" size="small" label="Email Reprezentant Legal" fullWidth margin="dense" 
                                {...register("lWorksite.generalSection.legalRepresentativeEmail",
                                    {pattern: {
                                        value: DataPattern.PATTERN_EMAIL_ADDRESS,
                                        message: ValidationMessages.INVALID_EMAIL_ADDRESS,
                                    }}
                                )} 
                                error={!!errors?.lWorksite?.generalSection?.legalRepresentativeEmail}
                                helperText={errors?.lWorksite?.generalSection?.legalRepresentativeEmail ? errors.lWorksite.generalSection.legalRepresentativeEmail.message : null}
                            />
                        </Grid>

                        {/*row*/}
                        <Grid item xs={4}>
                            <TextField variant="standard" size="small" label="Nume Reprezentant Legal" fullWidth margin="dense" 
                                {...register("lWorksite.generalSection.lucratorDesemnatName")} 
                                error={!!errors?.lWorksite?.generalSection?.lucratorDesemnatName}
                                helperText={errors?.lWorksite?.generalSection?.lucratorDesemnatName ? errors.lWorksite.generalSection.lucratorDesemnatName.message : null}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <TextField variant="standard" size="small" label="Telefon Reprezentant Legal" fullWidth margin="dense" 
                                {...register("lWorksite.generalSection.lucratorDesemnatPhone",
                                    {pattern: {
                                        value: DataPattern.PATTERN_PHONE_NUMBER,
                                        message: ValidationMessages.INVALID_PHONE_NUMBER,
                                    }}
                                )} 
                                error={!!errors?.lWorksite?.generalSection?.lucratorDesemnatPhone}
                                helperText={errors?.lWorksite?.generalSection?.lucratorDesemnatPhone ? errors.lWorksite.generalSection.lucratorDesemnatPhone.message : null}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <TextField variant="standard" size="small" label="Email Reprezentant Legal" fullWidth margin="dense" 
                                {...register("lWorksite.generalSection.lucratorDesemnatEmail",
                                    {pattern: {
                                        value: DataPattern.PATTERN_EMAIL_ADDRESS,
                                        message: ValidationMessages.INVALID_EMAIL_ADDRESS,
                                    }}
                                )} 
                                error={!!errors?.lWorksite?.generalSection?.lucratorDesemnatEmail}
                                helperText={errors?.lWorksite?.generalSection?.lucratorDesemnatEmail ? errors.lWorksite.generalSection.lucratorDesemnatEmail.message : null}
                            />
                        </Grid>

                    </Grid>
        </React.Fragment>
    );
}